module.exports = "/_next/static/images/25c4460a76236ce2595fa0821148661c-locked-deposits@2x.jpg";